module.exports = __webpack_public_path__ + "static/img/device.702e3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/smart-door/device.png
// module id = 4aHn
// module chunks = 1